module.exports = __webpack_public_path__ + "img/sat_act.07c23778.png";